import React from 'react';
import styled from 'styled-components';
import env from '../utils/env';

// Non-prod environment indicator. The kuori native shell hides the URL bar, so
// dev/test builds are otherwise visually identical to prod.
//
// Reads SOMIS_ENV via the `env` module (publicRuntimeConfig), NOT process.env:
// process.env is a build-time inline that is undefined in the browser bundle
// (the build never receives SOMIS_ENV), so a client-side process.env read
// rendered on the server then vanished on hydration. publicRuntimeConfig is a
// runtime value, identical on server and client. Renders nothing on prod/unset
// (fail-safe: only an explicit dev/test value shows anything).
const EnvLabel = styled.span`
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  user-select: none;
  white-space: nowrap;
`;

const EnvBadge = () => {
  const somisEnv = env.SOMIS_ENV;
  if (somisEnv !== 'dev' && somisEnv !== 'test') return null;
  return (
    <EnvLabel aria-label={`Environment: ${somisEnv}`}>{somisEnv}</EnvLabel>
  );
};

export default EnvBadge;
